var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-justify"},[_c('h1',{staticClass:"text-center mt-16"},[_vm._v(" Welcome to your Dashboard"),_c('br'),_c('span',{staticClass:"success--text"},[_vm._v(_vm._s(_vm.curUser.Fullname))])])])}
var staticRenderFns = []

export { render, staticRenderFns }